import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { useState } from "react";
import ContestDialogImage from "./../assets/Contest Dialog.jpg";
import ContestBannerImage from "./../assets/Contest Banner.jpg";
import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import "./isopure.css";
import MappingService from "../services/MappingService";
import ProductService from "../services/ProductService";
import isobanner from "../assets/iso-banner.jpg";

const dialogStyles = makeStyles((theme) => ({
  backDrop: {
    backdropFilter: "blur(5px)",
    backgroundColor: "rgba(0,0,30,0.4)"
  }
}));

const ISO = () => {
  const mappingService = new MappingService();
  const productService = new ProductService();
  const classes = dialogStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isIPLContestEligible, setIsIPLContestEligible] = useState(false);
  const [isIPLContestDialog, setIsIPLContestDialog] = useState(false);
  const [formData, setFormData] = useState({
    code: "",
    mobileNumber: "",
    email: "",
    onlineStore: "",
    CurrentLocation: "",
    state: "",
    qrTrackingId: "",
    brandId: "",
    city: "", // Added
    pincode: "", // Added
    country: "", // Added
    lat: "", // Added
    lon: "" // Added
  });
  const [errors, setErrors] = useState({});
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = {};
      if (!formData.code) {
        validationErrors.code = "Code is required";
      } else if (!/^[A-Z0-9]{6}$/.test(formData.code)) {
        validationErrors.code = "Code must be 6 uppercase letters or digits";
      }

      if (!formData.mobileNumber) {
        validationErrors.mobileNumber = "Mobile number is required";
      } else if (!formData.mobileNumber.match(/^[6-9]\d{9}$/)) {
        validationErrors.mobileNumber = "Please enter valid mobile number.";
      }

      if (!formData.onlineStore) {
        validationErrors.onlineStore = "Online store selection is required";
      }
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        mappingService.authenticateData(formData).then(async (response) => {
          if (response.responseCode === "200") {
            // Handle a successful response, e.g., display a success message
            const currentUrl = window.location.href;
            const data = {
              U: currentUrl,
              CurrentLocation: formData.CurrentLocation,
              state: formData.state,
              ScratchCode: formData.code,
              MobileNumber: formData.mobileNumber,
              Email: formData.email,
              OnlineStore: formData.onlineStore,
              QRTrackingId: formData.qrTrackingId,
              brandId: formData.brandId,
              City: formData.city,
              Pincode: formData.pincode,
              Country: formData.country,
              Lat: formData.lat,
              Long: formData.lon
            };

            productService
              .QRScratchTracking(data)
              .then(async (responseQRScratch) => {
                if (
                  responseQRScratch[0].status === "Fake Product" ||
                  responseQRScratch[0].status === "Number not mapped" ||
                  responseQRScratch[0].status === "Seq No exists in damage"
                ) {
                  setTimeout(() => {
                    setLoading(true);
                    navigate("/fake", {
                      state: {
                        QRData: data.U,
                        verificationLogId: responseQRScratch[0].id,
                        brandId: formData.brandId
                      }
                    });
                  }, 1000);
                } else {
                  setTimeout(
                    () => setLoading(true),
                    // navigate('/genuine', { state: { seqNo: response.data.seqNo, QRData: data.U, ProductName: response.data.name, ProductDescription: response.data.Productdesc, ProductImage: response.data.productimage, batchCode: response.data.batchCode, MfgDate: response.data.mfgDate, ManufacturedAt: response.data.manufacturedAt } }),
                    navigate("/genuine", {
                      state: {
                        ResponseData: response,
                        ResQRScratch: responseQRScratch[0],
                        mobileNo: formData.mobileNumber,
                        brandId: formData.brandId
                      }
                    }),
                    1000
                  );
                  //setLoading(false);
                  //toast.success(response.data.responseMessage);
                }
              });
          } else {
            // Handle errors, e.g., display an error message
            console.error("Form submission failed");
            const currentUrl = window.location.href;
            const data = {
              U: currentUrl,
              CurrentLocation: formData.CurrentLocation || "",
              state: formData.state,
              ScratchCode: formData.code,
              MobileNumber: formData.mobileNumber,
              Email: formData.email,
              OnlineStore: formData.onlineStore,
              QRTrackingId: formData.qrTrackingId,
              brandId: formData.brandId,
              City: formData.city,
              Pincode: formData.pincode,
              Country: formData.country,
              Lat: formData.lat,
              Long: formData.lon
            };
            productService
              .QRScratchTracking(data)
              .then(async (responseQRScratch) => {
                navigate("/fake", {
                  state: {
                    QRData: data.U,
                    verificationLogId: responseQRScratch[0].id,
                    brandId: formData.brandId
                  }
                });
              });
          }
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    // Function to get user's geolocation
    const getUserGeolocation = () => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            getCityFromCoordinates(position.coords);
          },
          (error) => {
            console.error("Error getting user location:", error);
            InsertQRTrackingData("", "", "", "", "", "", "", "");
          }
        );
      } else {
        console.error("Geolocation is not supported");
        //setLoading(false);
      }
    };
    getUserGeolocation();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("showIsoHeader", "true");
  }, []);

  // useEffect(() => {
  //   if (userLocation) {
  //     //console.log("LOCATION---", userLocation); // This will log whenever userLocation changes
  //     getCityFromCoordinates(userLocation);
  //   } else {
  //     InsertQRTrackingData(userLocation);
  //   }

  // }, [userLocation]);

  const InsertQRTrackingData = async (
    compAdd,
    state,
    city,
    pincode,
    country,
    lat,
    lon
  ) => {
    setLoading(true);
    try {
      const currentUrl = window.location.href;
      // const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
      // const requestData = urlParams.get('U');
      // const modifiedRequestData = requestData.replace(/^GL/, '');
      //const currentLocation = await getCityFromCoordinates(userLocation);
      const data = {
        U: currentUrl,
        CurrentLocation: compAdd,
        state: state,
        City: city, // Added
        Pincode: pincode, // Added
        Country: country, // Added
        Lat: lat, // Added
        Long: lon // Added
      };

      try {
        productService.QRTracking(data).then(async (response) => {
          if (response) {
            setFormData((prevFormData) => ({
              ...prevFormData,
              qrTrackingId: response[0].qrTrackingId,
              brandId: response[0].brandId
            }));
            setIsIPLContestEligible(response[0].isIPLContestEligible);
            setIsIPLContestDialog(response[0].isIPLContestEligible);
            setLoading(false);
          } else {
            console.error("API Error:", response);
            setLoading(false);
          }
        });
      } catch (error) {
        console.error("Request Error:", error);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const getCityFromCoordinates = async (userLocation) => {
    try {
      let data;
      let response;
      do {
        response = await getLocation(userLocation);
        data = await response.json();
      } while (!data);
      if (data.address) {
        const addressComponents = [
          data.address.road,
          data.address.industrial,
          data.address.suburb,
          data.address.city,
          data.address.town,
          data.address.state_district,
          data.address.state,
          data.address.postcode,
          data.address.country
        ];

        // Filter out undefined components
        const filteredAddressComponents = addressComponents.filter(
          (component) => component !== undefined
        );
        let city =
          data.address.city ||
          data.address.town ||
          data.address.village ||
          data.address.county;
        let state = data.address.state || data.address.state_district;
        // Join non-empty components with a space
        const completeAddress = filteredAddressComponents.join(" ");
        const concatenatedAddress = `${completeAddress} | ${city}`;

        setFormData((prevFormData) => ({
          ...prevFormData,
          CurrentLocation: completeAddress,
          state: state,
          city: city,
          pincode: data.address.postcode,
          country: data.address.country,
          lat: data.lat,
          lon: data.lon
        }));
        InsertQRTrackingData(
          completeAddress, // No coordinates here
          state,
          city,
          data.address.postcode,
          data.address.country,
          data.lat,
          data.lon
        );
        if (!city) {
          city = data.address.state;
        }

        return city || "City not found";
      } else {
        return "City not found";
      }
    } catch (error) {
      console.error("Error fetching city:", error);
      InsertQRTrackingData("", "", "", "", "", "", "", "");
      return "Error fetching city";
    }
  };

  const getLocation = async (userLocation) => {
    //const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${userLocation.latitude}&lon=${userLocation.longitude}&zoom=100&addressdetails=1`;
    const apiUrl = `https://geocode.maps.co/reverse?lat=${userLocation.latitude}&lon=${userLocation.longitude}&api_key=665dcea61841b296785394ivz8480ad`;
    const response = fetch(apiUrl);
    return response;
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <section id="venue">
            <div className="container-fluid">
              <div
                hidden={!isIPLContestEligible}
                className="row slidere-bg animate-in-down text-center"
              >
                <div className="text-center banner-img">
                  <img src={ContestBannerImage} />
                </div>
              </div>
              <div className="row slidere-bg2 animate-in-down px-0">
                <div className=" col-md-4 align-self-center text-white slidere dash px-0">
                  <div className="container px-0">
                    <div
                      className="form-container bg-grey pa rounded-0 iso"
                      id="login-form"
                    >
                      {/* <div className="card-header check">To Check your Product Authenticity</div> */}
                      <h3 className="blink-text text-black">
                        Product Authentication
                      </h3>
                      <form onSubmit={handleFormSubmit} className="px-4">
                        <input
                          type="text"
                          name="code"
                          placeholder="Enter your 6 Digit code here *"
                          className="mar-tp-16 b-input white-bg text-black custom-border"
                          maxLength={6}
                          value={formData.code}
                          onChange={handleInputChange}
                        />
                        {errors.code && (
                          <div className="text-red-500">{errors.code}</div>
                        )}
                        <h5 className="varification">
                          <p className="text-black">
                            The 6-Digit code is located under the Scratch area
                            on the sticker. Pls scratch it off to reveal the
                            code.
                          </p>
                        </h5>
                        <input
                          type="text"
                          name="mobileNumber"
                          placeholder="Enter your mobile number *"
                          className="mar-tp-16 b-input  white-bg text-black custom-border"
                          maxLength={10}
                          value={formData.mobileNumber}
                          onChange={handleInputChange}
                        />
                        {errors.mobileNumber && (
                          <div className="text-red-500">
                            {errors.mobileNumber}
                          </div>
                        )}
                        <input
                          hidden={isIPLContestEligible}
                          type="text"
                          name="email"
                          placeholder="Enter your email (Optional)"
                          className="mar-tp-16 b-input  white-bg text-black custom-border"
                          maxLength={100}
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        <select
                          className="custom-border form-control text-black white-bg "
                          id="user_time_zone"
                          size="0"
                          name="onlineStore"
                          value={formData.onlineStore}
                          onChange={handleInputChange}
                        >
                          <option value="">
                            Select where you bought from *
                          </option>
                          <option value="D2CWebsite">D2C Website</option>
                          <option value="Amazon">Amazon</option>
                          <option value="Flipkart">Flipkart</option>
                          <option value="Blinkit">Blinkit</option>
                          <option value="Zepto">Zepto</option>
                          <option value="SwiggyInstamart">
                            Swiggy Instamart
                          </option>
                          <option value="Other">Other online store</option>
                          <option value="NearYou">A Store near you</option>
                        </select>
                        {errors.onlineStore && (
                          <div className="text-red-500 mb-3">
                            {errors.onlineStore}
                          </div>
                        )}
                        <button type="submit" className="bg-green">
                          VERIFY
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="p-0 col-md-8">
                  <img src={isobanner} alt="" />
                </div>
              </div>
            </div>
          </section>

          <Dialog
            BackdropProps={{
              classes: {
                root: classes.backDrop
              }
            }}
            open={isIPLContestDialog}
            onClose={setIsIPLContestDialog}
            className="add"
          >
            <DialogContent style={{ backgroundColor: "transparent" }}>
              <div style={{ display: "inline-block" }}>
                <IconButton
                  aria-label="close"
                  onClick={() => setIsIPLContestDialog(false)}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 15,
                    top: -5,
                    color: theme.palette.grey[500],
                    disableFocusRipple: "true",
                    border: 0
                  })}
                >
                  &#10006;
                </IconButton>
              </div>
              <div style={{ display: "block" }}>
                <img
                  style={{ borderRadius: "15px" }}
                  src={ContestDialogImage}
                />
              </div>
            </DialogContent>
          </Dialog>

          {/* ======= Features Section ======= */}
          {/* <div className="jumbotron obinstance">
              <div className="row w-100 no-gutters" data-aos="fade-in">
                <div className="col-md-4">
                  <div className="card border-info mx-sm-1 p-4">
                    <img
                      src="https://authenticateon.in/static/media/tipsOne.b5253e85.svg"
                      alt="Image"
                      className="img-fluid" loading="lazy"
                    />
                    <div className="text-info text-center mt-3"><h4>Only accept products with an authentication sticker</h4></div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card border-info mx-sm-1 p-4">
                    <img
                      src="https://authenticateon.in/static/media/tipsTwo.5b048612.svg"
                      alt="Image"
                      className="img-fluid" loading="lazy"
                    />
                    <div className="text-success text-center mt-3"><h4>Don’t accept products with stickers that have been scratched off</h4></div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card border-info mx-sm-1 p-4">
                    <img
                      src="https://authenticateon.in/static/media/tipsThree.14312980.svg"
                      alt="Image"
                      className="img-fluid" loading="lazy"
                    />
                    <div className="text-danger text-center mt-3"><h4>Only buy from authorized retailers</h4></div>
                  </div>
                </div>

              </div>
            </div> */}

          {/* Feature End*/}
          {/* <section
              id="about"
              className="ftco-section ftc-no-pb default-padding"
            >
              <div className="container-fluid">
                <div className="row">

                  <div className="col-md-5">
                    <div className="about-img">
                      <img
                        src="img/about.jpg"
                        alt="Image"
                        className="img-fluid img-thumbnail" loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-7">
                    <h2 className=" mb-3 heading_about">
                      ABOUT OPTIMUM NUTRITION
                    </h2>
                    <div className="">
                      <p className="para_about">
                        Optimum Nutrition, Inc. (ON) is a wholly owned subsidiary of Glanbia, a leading international cheese and nutritional ingredients group. ON owns and operates two premium sports nutrition brands,
                        Optimum Nutrition and ABB Performance, providing a comprehensive line of products across multiple categories. </p>
                      <strong>
                        <p className="para_about">
                          From the very beginning in 1986, Optimum Nutrition has always
                          taken a hands-on approach to maintaining the very highest standards of quality.
                        </p>
                      </strong>
                    </div>

                  </div>
                </div>
              </div>
            </section> */}

          {/* Fact Start */}
          {/* <div className="fact">
              <a id="play-video" className="video-play-button" href="#" data-toggle="modal" data-target="#glassAnimals">
                <span></span>
              </a>
              <img src="img/youtube.jpg" alt="youtube-img" className="img-fluid" loading="lazy" />
              <div className="modal fade" id="glassAnimals" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">Optimum Nutrition (ON)</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <iframe id="glassAnimalsVideo" src="https://www.youtube.com/embed/FbLHp9GJm7I?si=pvP_cnZnxSIuylOS" frameborder="0" allowfullscreen loading="lazy"></iframe>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>

            </div> */}
          {/* Fact End */}

          {/* <div className="fact gray-bg">

              <img src="img/online.jpg" alt="youtube-img" className="img-fluid" loading="lazy" />

              <div className="section-header text-center mt-3">
                <h2>WE ARE PRESENT ON !</h2>
                <h3>Authorised Online Sellers</h3>
              </div>
              <div className="container-fluid onlinee boxe">
                <div className="row present ">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        OptimumNutrition.co.in
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Touchstone Teleservices Private Limited (TTPL)</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Healthkart.com
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Touchstone Teleservices Private Limited (TTPL)</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Nutrabay.com
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Nutrabay Retail Private Limited</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Pharmeasy
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Take it easy Pharmeasy</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="row present">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Moonstone Ventures LLP
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Moonstone Ventures LLP</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Superwell Comtrade Pvt. Ltd.
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Superwell Comtrade Pvt. Ltd.</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Netmeds

                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Netmeds</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Pharmeasy
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Take it easy Pharmeasy</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="row present">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Hyugalife.com
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">HyugaLife</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        halt.in
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Halt!</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        HealthXP
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">HealthXP</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Bodybuildingindia.com
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Body Building India</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="row present">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Blinkit.com
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Blinkit</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        1MG
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Tata 1mg Healthcare Solutions Private Limited Nextgen</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Amazon
                      </h5>
                      <div className="card-body">
                        <h4 className="card-title">Cloudtail India R K WORLDINFOCOM P LTD<br></br>

                          Touchstone Teleservices Pvt Ltd</h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="card">
                      <h5 className="card-header">
                        Flipkart</h5>
                      <div className="card-body">
                        <h4 className="card-title">SuperComNet <br></br>SUGSHAANnet</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          {/* <div className="container-fluid">
              <div className="section-header text-center mt-3">
                <h2>WE ARE PRESENT ON !</h2>
                <h3>Authorised Retail Store</h3>
              </div>
              <div className="row">
                <div className="col-md-5 col-lg-5 sociale">
                  <img src="img/retail.jpg" alt="youtube-img" className="img-fluid" loading="lazy" />
                </div>
                <div className="col-md-7 col-lg-7 contact-me">
                  <div className="footermy-contact ">

                    <div className="card">
                      <div className="card-header">Retail Store</div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <select className="form-control"><option value="">State</option><option value="Andhra Pradesh">Andhra Pradesh</option><option value="Assam">Assam</option><option value="Bihar">Bihar</option><option value="Chandigarh">Chandigarh</option><option value="Chhattisgarh">Chhattisgarh</option><option value="Goa">Goa</option><option value="Gujarat">Gujarat</option><option value="Haryana">Haryana</option><option value="Himachal Pradesh">Himachal Pradesh</option><option value="Jammu and Kashmir">Jammu and Kashmir</option><option value="Jharkhand">Jharkhand</option><option value="Karnataka">Karnataka</option><option value="Kerala">Kerala</option><option value="Madhya Pradesh">Madhya Pradesh</option><option value="Maharashtra">Maharashtra</option><option value="Manipur">Manipur</option><option value="Delhi">Delhi</option><option value="Orissa">Orissa</option><option value="Punjab">Punjab</option><option value="Rajasthan">Rajasthan</option><option value="Tamil Nadu">Tamil Nadu</option><option value="Telangana">Telangana</option><option value="Uttar Pradesh">Uttar Pradesh</option><option value="Uttarakhand">Uttarakhand</option><option value="West Bengal">West Bengal</option></select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <select className="form-control"><option value="">City</option></select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer pb-4">
                        <h3>Our Retailers</h3>
                        <p>
                          A B C NUTRITION CENTRE<br></br> SCF 22 1ST FLOOR KABIR PARKOPP G.N.U. 8432930000
                        </p>
                      </div>
                    </div>

                  </div>
                </div>


              </div>

            </div> */}
          {/* review Start */}

          {/* Contact Start */}
          {/* <div className="container-fluid">
              <div id="contact" className="contact wow fadeInUp default-padding">
                <div className="section-header text-center">
                  <h2>GET IN TOUCH !</h2>
                </div>
                <div className="row query-form contact-dataa ">
                  <div className="col-md-6">
                    <div className="contact-info">

                      <div className="contact-item">
                        <i className="flaticon-call" />
                        <div className="contact-text">
                          <h2>Customer Care Number </h2>
                          <p> 011 - 49594959</p>
                        </div>
                      </div>


                      <div className="contact-item">
                        <i className="flaticon-send-mail" />
                        <div className="contact-text">
                          <h2>Email</h2>
                          <p>indiacustomercare@glanbia.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="contact-form contact">
                      <div id="success" />
                      <h1>Reach Out To Us</h1>

                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          {/* Contact End */}

          {/* Footer Start */}
          <div
            className="footermy wow fadeIn  green-gradient"
            data-wow-delay="0.3s"
          >
            <div className="">
              {/* <div className="col-md-6 col-lg-6">
                    <div className="footermy-link">
                      <h2>Useful Pages</h2>
                      <a href="https://authenticateon.in/privacy">Privacy Policy </a>
                      <a href="https://authenticateon.in/tncHeader">Terms & Conditions</a>

                    </div>
                  </div> */}

              <div className="d-flex  footer-links align-items-center social-icone boxxe ml-5">
                {/* <h2 className="footer-title mt-4">Follow us by</h2> */}
                <div className="icons_container d-flex ml-3 ">
                  {/*<div className="icon facebook2">
                    <div className="tooltip">Facebook</div>
                    <a
                      href="https://www.facebook.com/OptimumNutritionIN"
                      target="_blank"
                    >
                      {" "}
                      <span>
                        <i className="fa fa-facebook-f"></i>
                      </span>
                    </a>
                  </div>*/}
                  {/* <div className="icon twitter">
                        <div className="tooltip">
                          Twitter
                        </div>
                        <a href="https://twitter.com/OptimumNutri_IN" target="_blank"><span><i className="fa fa-twitter"></i></span></a>
                      </div> */}
                  {/* <div className="icon instagram2">
                    <div className="tooltip">Instagram</div>
                    <a
                      href="https://www.instagram.com/optimumnutri_in/"
                      target="_blank"
                    >
                      {" "}
                      <span>
                        <i className="fab fa-instagram"></i>
                      </span>
                    </a>
                  </div>
                  <div className="icon youtube2">
                    <div className="tooltip">YouTube</div>
                    <a
                      href="https://www.youtube.com/user/OptimumNutriIN"
                      target="_blank"
                    >
                      <span>
                        <i className="fa fa-youtube"></i>
                      </span>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="container footermy-menu">
              <div className="f-menu"></div>
            </div>
            <div className=" text-white d-flex flex-column align-items-center justify-content-between">
              <div className="">
                {" "}
                © {new Date().getFullYear()} Optimum Nutrition, INC{" "}
              </div>
              <div className="copyright designedby flex-no-wrap">
                Design & Developed by{" "}
                <a
                  href="https://holostik.com/"
                  className="desinged-by link"
                  target="_blank"
                >
                  Holostik India Limited
                </a>
              </div>
            </div>
          </div>
          {/* Footer End */}
          <a href="#" className="back-to-top">
            <i className="fa fa-chevron-up" />
          </a>
        </div>
      )}
    </div>
  );
};

export default ISO;
